import React, {useState} from "react";
import {apiFetch} from "../../utils";
import {modals} from "../../ducks";
import {Button} from "react-bootstrap";
import ModalComponent from "../ModalComponent";
import registeredComponent from "../../utils/registeredComponent";
import {connect} from "react-redux";
import FlashMessage from "../FlashMessage/FlashMessage";

const PageEditor = ({pageId, name, formTemplateId, dispatch}) => {
  const [pageName, setName] = useState(name);
  const [errorMessage, setErrorMessage] = useState(null)

  const onSubmit = () => {
    apiFetch.put(
      {},
      'form_templates/' + formTemplateId,
      {name: pageName, page_id: pageId}
    ).then(() => {
      $('.sa-form-nav-page-name').text(pageName);
      $('#form_preview_page_select').find(':selected').text(pageName);
      dispatch(modals.actions.hide());
    }).catch((response) => {
      setErrorMessage(response.error);
    })
  }

  const buttons = [<Button type='submit' className='btn btn-primary'
                           onClick={() => onSubmit()}>Save</Button>]

  return (
      <ModalComponent title={'Edit Page Name'} buttons={buttons}>
        {errorMessage && <FlashMessage type={'danger'} message={errorMessage}/>}
        <input value={pageName} onChange={(e) => setName(e.target.value)}/>
      </ModalComponent>
    )
}

export default registeredComponent(PageEditor)(connect()(PageEditor));
